'use strict';

var AmortizationTypes = /*#__PURE__*/function (AmortizationTypes) {
  AmortizationTypes["FIXED"] = "Fixed";
  AmortizationTypes["ARM"] = "ARM";
  return AmortizationTypes;
}({});
var ARMFixedTerms = /*#__PURE__*/function (ARMFixedTerms) {
  ARMFixedTerms["THREE_YEAR"] = "ThreeYear";
  ARMFixedTerms["FIVE_YEAR"] = "FiveYear";
  ARMFixedTerms["SEVEN_YEAR"] = "SevenYear";
  ARMFixedTerms["TEN_YEAR"] = "TenYear";
  return ARMFixedTerms;
}({});
var LoanPurposes = /*#__PURE__*/function (LoanPurposes) {
  LoanPurposes["PURCHASE"] = "Purchase";
  LoanPurposes["REFINANCE"] = "Refinance";
  LoanPurposes["OTHER"] = "OTHER";
  return LoanPurposes;
}({});
var LoanTypes = /*#__PURE__*/function (LoanTypes) {
  LoanTypes["CONVENTIONAL"] = "Conventional";
  LoanTypes["FHA"] = "FHA";
  LoanTypes["VA"] = "VA";
  LoanTypes["USDA"] = "USDA";
  LoanTypes["NON_CONVENTIONAL"] = "Non-Conventional";
  return LoanTypes;
}({});
var LoanTypeHeadingTitle = /*#__PURE__*/function (LoanTypeHeadingTitle) {
  LoanTypeHeadingTitle["FHAHeadingTitle"] = "FHA loan";
  LoanTypeHeadingTitle["VAHeadingTitle"] = "VA home loan";
  LoanTypeHeadingTitle["JUMBOHeadingTitle"] = "jumbo loan";
  LoanTypeHeadingTitle["Fixed30YearHeadingTitle"] = "30-year, fixed-rate";
  LoanTypeHeadingTitle["Fixed15YearHeadingTitle"] = "15-year, fixed-rate";
  return LoanTypeHeadingTitle;
}({});
var LoanTypeValues = /*#__PURE__*/function (LoanTypeValues) {
  LoanTypeValues["FHA"] = "FHA";
  LoanTypeValues["VA"] = "VA";
  LoanTypeValues["JUMBO"] = "Jumbo";
  LoanTypeValues["Fixed30Year"] = "30YrFixed";
  LoanTypeValues["Fixed15Year"] = "15YrFixed";
  LoanTypeValues["ARM10Year"] = "10YrARM";
  LoanTypeValues["ARM7Year"] = "7YrARM";
  LoanTypeValues["ARM5Year"] = "5YrARM";
  LoanTypeValues["All"] = "All";
  return LoanTypeValues;
}({});
var ConventionalYears = /*#__PURE__*/function (ConventionalYears) {
  ConventionalYears[ConventionalYears["Fixed15Year"] = 15] = "Fixed15Year";
  ConventionalYears[ConventionalYears["Fixed30Year"] = 30] = "Fixed30Year";
  return ConventionalYears;
}({});
var OccupancyTypes = /*#__PURE__*/function (OccupancyTypes) {
  OccupancyTypes["PRIMARY_RESIDENCE"] = "PrimaryResidence";
  OccupancyTypes["SECOND_HOME"] = "SecondHome";
  OccupancyTypes["INVESTMENT_PROPERTY"] = "InvestmentProperty";
  return OccupancyTypes;
}({});
var PropertyTypes = /*#__PURE__*/function (PropertyTypes) {
  PropertyTypes["DETACHED"] = "Detached";
  PropertyTypes["ATTACHED"] = "Attached";
  PropertyTypes["CONDO_LOW_RISE"] = "CondoLowRise";
  PropertyTypes["CONDO_HIGH_RISE"] = "CondoHighRise";
  PropertyTypes["COOPERATIVE"] = "Cooperative";
  PropertyTypes["MANUFACTURED_HOME"] = "ManufacturedHome";
  PropertyTypes["MULTI_UNIT"] = "MultiUnit";
  return PropertyTypes;
}({});
var SourceIds = /*#__PURE__*/function (SourceIds) {
  SourceIds["RATEGRID"] = "RATEGRID";
  SourceIds["RATENOTIFICATION"] = "RATENOTIFICATION";
  SourceIds["DMX"] = "DMX";
  SourceIds["TOTO"] = "TOTO";
  SourceIds["OWNING"] = "OwningWebsite";
  return SourceIds;
}({});

exports.ARMFixedTerms = ARMFixedTerms;
exports.AmortizationTypes = AmortizationTypes;
exports.ConventionalYears = ConventionalYears;
exports.LoanPurposes = LoanPurposes;
exports.LoanTypeHeadingTitle = LoanTypeHeadingTitle;
exports.LoanTypeValues = LoanTypeValues;
exports.LoanTypes = LoanTypes;
exports.OccupancyTypes = OccupancyTypes;
exports.PropertyTypes = PropertyTypes;
exports.SourceIds = SourceIds;
